import { useEffect, useState } from "react";
import api from "../lib/api";

let cache = null;
let inflight = null;

export function usePublicLocations() {
  const [locations, setLocations] = useState(cache);

  useEffect(() => {
    if (cache) { setLocations(cache); return; }
    if (!inflight) {
      inflight = api
        .get("/settings/locations")
        .then((r) => { cache = r.data; return r.data; })
        .catch(() => [])
        .finally(() => { inflight = null; });
    }
    let cancelled = false;
    inflight.then((data) => { if (!cancelled && data) setLocations(data); });
    return () => { cancelled = true; };
  }, []);

  return locations || [];
}

export function clearPublicLocationsCache() {
  cache = null;
}
